import React from 'react';
import PropTypes from 'prop-types';

class FieldSet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { children, title, style, } = this.props;
    const fieldSetStyle = {
      ...style,
      minHeight: '10%',
    };

    return (
      <fieldset className="border rounded p-3">
        <legend className="w-auto small">{title}</legend>
        <div className="overflow-auto" style={fieldSetStyle}>
          {children}
        </div>
      </fieldset>
    );
  }
}

FieldSet.defaultProps = {
  children: null,
  title: '',
  style: {},
};

FieldSet.propTypes = {
  children: PropTypes.oneOfType([ PropTypes.object, PropTypes.array, ]),
  title: PropTypes.string,
  style: PropTypes.object,
};

export default FieldSet;
